export const STEPS = {
  SELFIE: 'SELFIE',
  SELFIE_CONFIRM: 'SELFIE_CONFIRM',
};

// These are the basic sizes required for account thumbnails within the webapp
export const DEFAULT_THUMBNAIL_SIZES = [
  {
    url: '',
    size_code: 'small',
    __typename: 'PhotoURLType',
  },
  {
    url: '',
    size_code: 'small2x',
    __typename: 'PhotoURLType',
  },
];
